module.exports = {
  title: process.env.VUE_APP_title,
  BASE_URL: process.env.VUE_APP_BASE_URL, //项目地址
  BASE_API_URL: process.env.VUE_APP_BASE_API_URL, //接口地址
  BASE_IMAGE_URL: process.env.VUE_APP_BASE_IMAGE_URL, //图片地址
  PATH_SEP: process.env.VUE_APP_PATH_SEP, //服务器操作系统目录分隔符 "\\" OR "/"

};
